import axiosInstance from 'api/axiosInstance';

/**
 * Re-index a single case's embedding after create/update.
 * Fires and forgets — errors are logged but don't affect the user flow.
 */
const indexCase = (caseId: number): void => {
  axiosInstance
    .post('/api3.2/search/index', { caseIds: [caseId] })
    .catch((error) => {
      console.warn('[indexCase] Background re-index failed (non-fatal):', error.message);
    });
};

export default indexCase;
